export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1595495745827-85bcc5c9a028?crop=entropy&cs=srgb&fm=jpg&q=80&w=2400",
  garden: "https://images.unsplash.com/photo-1494548162494-384bba4ab999?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  forest: "https://images.unsplash.com/photo-1698420204264-27e3944d3c0f?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  shore: "https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
};

export const ENV_KEYS = ["garden", "forest", "shore"];
export const MODEL_KEYS = ["classic", "modern", "natural"];
export const SPECIES_KEYS = ["dog", "cat", "rabbit", "bird", "horse", "hamster", "turtle", "other"];
export const FLOWER_KINDS = ["rose", "lily", "daisy", "sunflower"];
export const FLOWER_COLORS = { rose: "#c4566a", lily: "#f3eee6", daisy: "#fbf6e9", sunflower: "#e8b53c" };

export const EPITAPH_FONTS = {
  classic: { css: '"Playfair Display", serif', italic: true, weight: 600, scale: 1 },
  script: { css: '"Parisienne", cursive', italic: false, weight: 400, scale: 1.35 },
  hand: { css: '"Caveat", cursive', italic: false, weight: 700, scale: 1.35 },
  modern: { css: '"Jost", sans-serif', italic: false, weight: 500, scale: 0.95 },
  antique: { css: '"IM Fell English", serif', italic: true, weight: 400, scale: 1.1 },
};
export const fontStyle = (key) => {
  const f = EPITAPH_FONTS[key] || EPITAPH_FONTS.classic;
  return { fontFamily: f.css, fontStyle: f.italic ? "italic" : "normal", fontWeight: f.weight };
};
